<template>
    <component
        :is="tag"
        :class="['link', `link--${variant}`]"
        :data-theme="theme"
        :disabled="disabled"
        :href="href"
    >
        <i
            v-if="icon && iconPosition == 'left'"
            :class="`i-${icon} pos-${iconPosition}`"
        />
        <slot />
        <i
            v-if="icon && iconPosition == 'right'"
            :class="`i-${icon} pos-${iconPosition}`"
        />
    </component>
</template>

<script>
    export default {
        name: 'CoreLink',
        props: {
            tag: {
                type: String,
                default: 'button'
            },
            href: {
                type: [String, Boolean],
                default: false
            },
            variant: {
                type: String,
                default: 'inline'
            },
            theme: {
                type: String,
                default: 'secondary'
            },
            icon: {
                type: String,
                default: ''
            },
            iconPosition: {
                type: String,
                default: 'right'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
.link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    line-height: 1rem;
    cursor: pointer;

    @extend %link-variants;
    @extend %link-themes;

    &:disabled {
        pointer-events: none;
    }

    span {
        & + i {
            margin-left: 1rem;
        }
    }

    i {
        font-size: 0.875rem;

        &.pos-left {
            margin-right: 0.5rem;
        }

        &.pos-right {
            margin-left: 0.5rem;
        }
    }
}

%link-variants {
    &.link--inline {
        font-weight: bold;

        &:disabled {
            color: #909090; // todo-maarten: later variabel
        }
    }

    &.link--underline {
        font-weight: normal;
        text-decoration: underline;
    }
}

%link-themes {
    &[data-theme=primary] {
        color: var(--primary);

        &:hover {
            color: var(--secondary);
        }
    }

    &[data-theme=secondary] {
        color: var(--secondary);

        &:hover {
            color: var(--primary);
        }
    }

    &[data-theme=dark] {
        color: var(--dark);

        &:hover {
            color: var(--primary);
        }
    }
}
</style>
